module.exports = __webpack_public_path__ + "media/images/front/igakushoin_logo-1f286d86997f55aced0da0c58ca9f802.svg";